import { getContainerTypes } from "../../productCommons/index.js";

export const getItemType = (containerType: string | null) => {
  if (!containerType) {
    return null;
  }

  const itemTypeList = [
    "keg",
    "can",
    "cask",
    "bottle",
    "snack",
    "glassware",
    "bagInBox",
    "jerryCan",
    "box",
  ] as const;

  const containerTypesList = getContainerTypes(containerType);
  return (
    itemTypeList.find((itemType) => {
      return containerTypesList.includes(itemType);
    }) ?? null
  );
};
